<app-main
  class="toolbar"
  (toggleDrawer)="toggleDrawer(drawer, $event)"
  *ngIf="
    isLog && router.url !== '/confirm-mail' && router.url !== '/reset-password'
  "
></app-main>

<mat-drawer-container
  class="container"
  [style.height]="
    isLog && router.url !== '/confirm-mail' && router.url !== '/reset-password'
      ? 'calc(100vh - 64px)'
      : '100vh'
  "
  autosize
  [hasBackdrop]="true"
  style="--isLog:var(--isLog){{ isLog ? 1 : 0 }}"
>
  <mat-drawer #drawer class="sidenav" mode="over">
    <ul>
      <ng-container *ngFor="let n of nav">
        <li
          *ngIf="n.title !== 'Newsletters'"
          [routerLink]="n.route"
          routerLinkActive="router-link-active"
          (click)="drawer.toggle()"
        >
          <fa-icon [icon]="n.icon"></fa-icon>
          {{ n.title }}
        </li>
      </ng-container>
    </ul>

    <div class="powered_by_bizzdev">
      <span>Powered by</span>
      <div class="bizzdev">
        <img src="assets/icons/logo_bizzdev.jpg" alt="" />
        <a href="https://www.bizzdev.com/" target="_blank"> BizzDev</a>
      </div>
    </div>

    <a href="https://www.ramdamfestival.be/" target="_blank" class="ramdam"
      ><img
        src="assets/img/TOURNAI RAMDAM FEST - logo BLC&RGE.png"
        alt="logo_ramdam"
    /></a>
  </mat-drawer>

  <div class="sidenav-content">
    <router-outlet></router-outlet>

    <div
      class="powered_by_bizzdev"
      *ngIf="
        isLog &&
        router.url !== '/confirm-mail' &&
        router.url !== '/reset-password'
      "
    >
      <span>Powered by</span>
      <div class="bizzdev">
        <img src="assets/icons/logo_bizzdev.jpg" alt="" />
        <a href="https://www.bizzdev.com/" target="_blank"> BizzDev</a>
      </div>
    </div>
  </div>
  <div class="privacy_policy">
    <a
      href="https://www.ramdamfestival.be/politique-de-confidentialite/"
      target="_blank"
      >Privacy Policy</a
    >
  </div>
</mat-drawer-container>
